// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetV3Symbols (params?: {}): Promise<Dict>;
    publicGetV3HistoryFunding (params?: {}): Promise<Dict>;
    publicGetV3Ticker (params?: {}): Promise<Dict>;
    publicGetV3Klines (params?: {}): Promise<Dict>;
    publicGetV3Trades (params?: {}): Promise<Dict>;
    publicGetV3Depth (params?: {}): Promise<Dict>;
    publicGetV3Time (params?: {}): Promise<Dict>;
    publicGetV3DataAllTickerInfo (params?: {}): Promise<Dict>;
    privateGetV3Account (params?: {}): Promise<Dict>;
    privateGetV3AccountBalance (params?: {}): Promise<Dict>;
    privateGetV3Fills (params?: {}): Promise<Dict>;
    privateGetV3OrderFills (params?: {}): Promise<Dict>;
    privateGetV3Order (params?: {}): Promise<Dict>;
    privateGetV3HistoryOrders (params?: {}): Promise<Dict>;
    privateGetV3OrderByClientOrderId (params?: {}): Promise<Dict>;
    privateGetV3Funding (params?: {}): Promise<Dict>;
    privateGetV3HistoricalPnl (params?: {}): Promise<Dict>;
    privateGetV3OpenOrders (params?: {}): Promise<Dict>;
    privateGetV3Transfers (params?: {}): Promise<Dict>;
    privateGetV3Transfer (params?: {}): Promise<Dict>;
    privateGetV3StockAccount (params?: {}): Promise<Dict>;
    privatePostV3DeleteOpenOrders (params?: {}): Promise<Dict>;
    privatePostV3DeleteClientOrderId (params?: {}): Promise<Dict>;
    privatePostV3DeleteOrder (params?: {}): Promise<Dict>;
    privatePostV3Order (params?: {}): Promise<Dict>;
    privatePostV3SetInitialMarginRate (params?: {}): Promise<Dict>;
    privatePostV3TransferOut (params?: {}): Promise<Dict>;
    privatePostV3ContractTransferOut (params?: {}): Promise<Dict>;
    privatePostV3ContractTransferTo (params?: {}): Promise<Dict>;
    privatePostV3SubmitWithdrawClaim (params?: {}): Promise<Dict>;
    privatePostV3StockRegisterAccount (params?: {}): Promise<Dict>;
    privatePostV3StockGenerateApi (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
